export default __webpack_public_path__ + "static/media/flag-viet-nam.c46949a1.svg";